module.exports = __webpack_public_path__ + "static/media/izolacjamniejsza.0292eed6.svg";